import { Box } from "@mui/material";
import useClientContext from "../../contexts/useClientContext";
import type { RelativeLogoSize } from "../../store/state/user/types";

const getLogoHeight = (size: RelativeLogoSize | undefined): number => {
  switch (size) {
    case "Small":
      return 40;
    case "Medium":
      return 48;
    case "Large":
      return 56;
    default:
      return 40;
  }
};

const PortalLogo = () => {
  const { portalSettings } = useClientContext();

  return (
    <Box
      component="img"
      alt="Client Logo"
      src={portalSettings?.logoTypeUrl}
      sx={{ maxHeight: getLogoHeight(portalSettings?.logoTypeSize) }}
    />
  );
};

export default PortalLogo;
